import { BaseSearchDTO } from "../../../../../uinspect/src/app/global/interfaces";

export interface UInspectQuestionOptionSearchDTO extends BaseSearchDTO {
  filters?: {
    id: number,
  };
}
